import { isRecord } from '@/helpers/isRecord'
import { NotificationCategory } from '@/types'

import {
    NotificationActivity,
    NotificationChannel,
    NotificationItem,
    NotificationSource,
} from './Notification'

const getChannelDisplayTitle = (channel: NotificationChannel): string | undefined => {
    const data: unknown = channel.data
    const channelName = isRecord(data) && typeof data.name === 'string' ? data.name : undefined

    if (channelName) {
        return channelName
    }

    const members = Object.values(channel.state.members)

    if (members.length !== 2) {
        return undefined
    }

    const currentUserId = channel.getClient().userID
    const otherMember = members.find(member => member.user?.id !== currentUserId)

    return otherMember?.user?.name
}

export const transformActivityToNotification = (
    activity: NotificationActivity,
    lastReadAt: Date | null,
): NotificationItem => ({
    id: activity.id,
    source: NotificationSource.feed,
    category: NotificationCategory.feedPost,
    title: activity.user.name ?? activity.user.id,
    body: activity.custom.title ?? activity.text,
    createdAt: activity.created_at,
    read: !! lastReadAt && activity.created_at <= lastReadAt,
    actor: {
        id: activity.user.id,
        name: activity.user.name,
        image: activity.user.image,
    },
})

export const transformChannelToNotification = (channel: NotificationChannel): NotificationItem => {
    const { latestMessages, last_message_at: lastMessageAt } = channel.state
    const lastMessage = latestMessages[latestMessages.length - 1]
    const sender = lastMessage?.user
    const unreadCount = channel.countUnread()

    return {
        id: channel.id ?? channel.cid,
        source: NotificationSource.chat,
        category: NotificationCategory.chatMessages,
        title: getChannelDisplayTitle(channel) ?? '',
        body: lastMessage?.text,
        createdAt: lastMessage?.created_at ?? lastMessageAt ?? new Date(0),
        read: unreadCount === 0,
        unreadCount,
        actor: sender ? {
            id: sender.id,
            name: sender.name,
            image: sender.image,
        } : undefined,
    }
}

export const mergeNotificationSources = (...sources: NotificationItem[][]): NotificationItem[] => (
    sources.flat().sort((notificationA, notificationB) => notificationB.createdAt.getTime() - notificationA.createdAt.getTime())
)
